import { useState } from 'react';
import { useAgentAuth } from '../../../contexts/AgentAuthContext';
import { useAgentToolUsage } from '../../../hooks/useAgentToolUsage';
import { TOOL_IDS } from '../../../lib/agents/firestore-schema';
import { Button } from '../../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';

export default function PlaceholderTool() {
  const { agentProfile } = useAgentAuth();
  const usage = useAgentToolUsage(agentProfile, TOOL_IDS.PLACEHOLDER);
  const [stepDone, setStepDone] = useState(false);

  const handleCompleteStep = () => {
    usage.recordStep('sample_step', { note: 'Placeholder step completed' });
    setStepDone(true);
  };

  return (
    <div>
      <h1 className="text-2xl font-semibold text-foreground mb-2">Placeholder Tool</h1>
      <p className="text-muted-foreground mb-6">
        This is a sample tool to verify the framework: auth, routing, and usage tracking.
      </p>
      <Card>
        <CardHeader>
          <CardTitle>Sample step</CardTitle>
          <CardContent className="pt-0">
            <Button onClick={handleCompleteStep} disabled={stepDone}>
              {stepDone ? 'Step recorded' : 'Complete sample step'}
            </Button>
            {stepDone && (
              <p className="mt-2 text-sm text-muted-foreground">
                Usage event recorded. Check Firestore collection agentToolUsage.
              </p>
            )}
          </CardContent>
        </CardHeader>
      </Card>
    </div>
  );
}
